import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { StoreState } from './store.types';

import { StoreModel } from '~/core/models';

const initialState: StoreState = {
  selectedStore: undefined,
  restorableStoreId: undefined,
};

const storeSlice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    updateSelectedStore: (
      state,
      action: PayloadAction<StoreModel | undefined>
    ) => {
      state.selectedStore = action.payload;
    },
    updateRestorableStoreId: (
      state,
      action: PayloadAction<number | undefined>
    ) => {
      state.restorableStoreId = action.payload;
    },
  },
});

export const { updateSelectedStore, updateRestorableStoreId } =
  storeSlice.actions;

export default storeSlice.reducer;
